'use client';

import React from 'react';
import { SpacingType, sectionVariants } from "@/types";
import { SectionWrapper } from '../components/SectionWraper';
import parse from 'html-react-parser';

interface SectionProps {
  darkMode?: boolean;
  variant?: sectionVariants;
  spacing?: SpacingType;
  title?: string;
  content?: string;
  listContent?: {
    icon?: string;
    title?: string;
    content?: string;
  }[];
  attributes?: React.HTMLProps<HTMLElement>;
}

export const ContactPageContent = ({ 
  spacing, 
  darkMode = false, 
  title,
  content,
  listContent,
  variant = 'A', 
  attributes,
}: SectionProps) => {

  return (
    <SectionWrapper
      usedInPageNav={false}
      pageNavTitle={''}
      themeChangeOnScroll={false}
      spacing={spacing}
      variant={variant}
      darkMode={darkMode}
      heroSection={false}
      componentName="section"
      attributes={attributes}
      className="bg-transparent"
    > 
      <div className="flex flex-col pr-0 lg:pr-8 2xl:pr-56 gap-8 lg:gap-16">
        {(title || content) && (
          <div className="flex flex-col gap-8">
            {title && <h2>{title}</h2>}
            {content && <div className="paragraph-lg text-muted-foreground">{parse(content)}</div>}
          </div>
        )}
        {listContent && (
          listContent?.map((item, index) => (
            <div key={index} className="flex flex-col gap-1">
              {item.icon && <div className='bg-white size-12 p-3 mb-3 rounded-lg flex items-center justify-center'>
                <span className='material-symbols-outlined text-brand'>{item.icon}</span>
              </div>}
              {item.title && <div className='paragraph-lg font-bold'>{item.title}</div>}
              {item.content && <div className='paragraph-base text-muted-foreground flex flex-col gap-1'>{parse(item.content ?? '')}</div>}
            </div>
          ))
        )}
      </div>
    </SectionWrapper>
  );
}; 